import FunctionsOutlinedIcon from "@mui/icons-material/FunctionsOutlined";

import { getSelectedItemsSum } from "components/Footer/aggFuncs";
import FooterHandleStatus from "pages/EstimateViewer/components/Footer/FooterHandleStatus";

const SummaryEstimateViewerFooterSettings = ({ clickedTableCtrlRows, headerData, treeWidth, projectMeta, userPermissions, userSettings }) => {
	return [
		{
			type: "common",
			text: null,
			icon: null,
			position: "left",
			callback: () => {},
			style: { width: treeWidth, minWidth: treeWidth },
			jsx: <FooterHandleStatus meta={projectMeta} />,
			isVisible: userPermissions?.is_expert === true && userSettings?.projectTree?.lsrStatusUsage === true,
		},
		{
			text: headerData?.full_total_price != null ? `${headerData?.full_total_price} тыс. руб.` : "",
			position: "left",
		},
		{
			type: "common",
			text: `Выделено ячеек: ${clickedTableCtrlRows.length}. Сумма: ${getSelectedItemsSum({ clickedTableCtrlRows }) || ""}`,
			icon: <FunctionsOutlinedIcon />,
			position: "right",
			isVisible: true,
			callback: () => {},
			style: {},
			jsx: null,
		},
	];
};

export default SummaryEstimateViewerFooterSettings;
